import { SalesOrderDraft } from "../Models/SalesOrder";

//the Order and Quote screens are the same screens; this is what differs between them
export type SalesDocMode = "order" | "quote";

export const salesDocText = (mode: SalesDocMode) =>
  mode === "quote"
    ? { noun: "quote", Noun: "Quote", post: "Post Quote", customerRoute: "/quotecustomer", docRoute: "/quote" }
    : { noun: "order", Noun: "Order", post: "Post Order", customerRoute: "/salesordercustomer", docRoute: "/salesorder" };

//the order or quote being built is kept in localStorage so a refresh or a dropped connection does not lose it.
//Each mode has its own, so an order and a quote can be in progress at the same time.
const draftKey = (mode: SalesDocMode) => `e_sales${mode}_${process.env.REACT_APP_PROVIDER}`;

export const loadSalesOrderDraft = (mode: SalesDocMode): SalesOrderDraft | null => {
  try {
    const json = localStorage.getItem(draftKey(mode));
    return json ? (JSON.parse(json) as SalesOrderDraft) : null;
  } catch {
    return null;
  }
};

export const saveSalesOrderDraft = (mode: SalesDocMode, draft: SalesOrderDraft | null): void => {
  try {
    if (draft) {
      localStorage.setItem(draftKey(mode), JSON.stringify(draft));
    } else {
      localStorage.removeItem(draftKey(mode));
    }
  } catch {
    //storage full or blocked - it still works, it just will not survive a refresh
  }
};

export const todayIso = (): string => {
  const d = new Date();
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
